export default "__VITE_ASSET__DqwS0d3L__"